<template>
    <div>
        <CostPivotContainer
            v-if="initialized"
            :userIdx="userIdx"
        >
            <template v-slot:groupAndAccounts="{ loading }">
                <b-overlay
                    :show="loading"
                    rounded="sm"
                    :opacity="0.1"
                >
                    <template #overlay>
                        <div></div>
                    </template>
                    <CommonSelectGroup :clearable="isClearable('common-select-group', cmpArr)"/>
                    <CommonSelectProject :clearable="isClearable('common-select-project', cmpArr)"/>
                </b-overlay>
            </template>
        </CostPivotContainer>
        <div v-else class="p-1 text-center">
            {{ $t('v4["Loading base data for cost pivot page..."]') }}
            <p class="my-50">
                <b-spinner />
            </p>
            {{ $t('v4["Please wait"]') }}
        </div>
    </div>
</template>

<script>
import store from '@/store'
import CostPivotStore from '@/modules/CostPivot/_store'
import CostPivotContainer from '@/modules/CostPivot'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'
import CommonSelectGroup from '@/components/commonSelect/CommonSelectGroup'
import CommonSelectProject from '@/components/commonSelect/CommonSelectProject'
const STORE_KEY = '$_costPivot'

export default {
    components: {
        CommonSelectGroup,
        CommonSelectProject,
        CostPivotContainer
    },
    setup (props, context) {
        const cmpArr = [
            'common-select-group',
            'common-select-project',
            'common-select-calendar-month-range'
        ]
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const initialized = ref(false)
        const {
            isClearable,
            selectedGroup,
            selectedProject,
            qtypeParam,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        if (!selectedProject.value?.projectIdx && !selectedGroup.value?.groupIdx) {
            setInitialAccountSelect(true)
        }
        const costPivotStatus = computed(() => store.getters[`${STORE_KEY}/costPivotStatus`])
        const userIdx = computed(() => store.getters.authUserInfo.userIdx)
        const params = {
            ...qtypeParam.value,
            compositSources: ['usageAccountId', 'ym'],
            value: 'unblendedCost',
            indexes: []
        }
        store.dispatch(`${STORE_KEY}/getCostPivot`, params).then((response) => {
            store.dispatch(`${STORE_KEY}/getCostPivotFilterNames`, { userIdx: userIdx.value })
            initialized.value = true
        })
        store.dispatch(`${STORE_KEY}/getUserTag`)
        return {
            cmpArr,
            userIdx,
            initialized,
            selectedGroup,
            selectedProject,
            costPivotStatus,
            isClearable
        }
    },
    beforeRouteEnter (to, from, next) {
        const internalUser = computed(() => store.getters.internalUser)
        if (to.name === 'pivotNew' && internalUser.value) {
            next({ name: 'pivot' })
        }

        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, CostPivotStore)
        }

        next()
    }
}
</script>

<style>

</style>
